import { Table } from '@/components/product_specification/table'
import { ProductCategoryProduct } from '@/types'
interface Props {
  id: string
}

export const EditSpecifications = ({ id }: Props) => {
  return (
    <Table filters={ { productIdEq: id, productTypeEq: ProductCategoryProduct.Package } } createable deleteable />
  )
}
